<template>

    <div class="consent__page-container" v-show="showPage">

        <mq-layout class="full" mq="lg">

            <header-band
                :back="true"
                :blueCleanfox="true"
                :title="'Cleanfox'"
                @eventBack="back"
            ></header-band>

        </mq-layout>

        <div class="new-consent">

            <div class="content">

                <div class="bloc-consent">

                    <h1>{{ $t('consent_title') }}</h1>

                    <markdown :text="$t('consent_cleanfox_subtitle_web')" class="paragraph"></markdown>
                </div>

                <div class="bloc-overflow">

                    <div class="subtitle">
                        <img src="/img/icons/chart-pie-green.svg">
                        <span>{{ $t('consent_how_works_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_cleanfox__data_collection_web')" class="paragraph" :blank="true"></markdown>

                    <div class="gap"></div>

                    <div class="subtitle">
                        <img src="/img/icons/lock-green.svg">
                        <span>{{ $t('consent_data_protected_title') }}</span>
                    </div>

                    <markdown :text="$t('consent_cleanfox_protection')" class="paragraph"></markdown>

                </div>

                <div class="bloc-consent">

                    <button class="cta" @click="loginPage">{{ $t('consent_cleanfox_lets_go') }}</button>
                    <div v-if="errorInConsentApi" class="error">Retry</div>

                    <markdown :text="$t('consent_cleanfox_under_cta_web')" class="end-paragraph"></markdown>

                </div>
            </div>


        </div>

        <block-mobile-popup :provider="provider" @unblock="activeConsentPage"></block-mobile-popup>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Consent from '../modules/consent'
import SessionStorage from '../helpers/sessionStorage'

import Auth from '../modules/auth'
import I18n from '../modules/i18n'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import BlockMobilePopup from '../components/loginFlow/BlockMobilePopup'
import HeaderBand from '../components/headers/HeaderBand'
import Markdown from '../components/Markdown'

import {routerPushHelper} from '../router'


export default {

    name: 'consent-page',
    components: {BlockMobilePopup, HeaderBand, Markdown},

    computed: {
        ...Vuex.mapGetters(['page'])
    },

    data() {
        return {
            provider: '',
            toPath: '',
            invalidGrant: false,
            showPage: false,
            errorInConsentApi: false
        }
    },

    created() {
        this.provider = this.$route.query.provider
        this.toPath = this.$route.query.toPath
        this.invalidGrant = this.convertQueryToBooleanOrUndefined(this.$route.query.ig )
    },

    async mounted() {
        // scroll top for Iphone
        window.scrollTo(0, 0)

        // if (false) block-mobile-popup call activeConsentPage()
        if (this.$mq === 'lg' || (this.provider !== '' && this.provider !== 'google')) {
            this.activeConsentPage()
        }
    },

    methods: {

        convertQueryToBooleanOrUndefined(value) {
            if  (value === 'true') {
                return true
            }
            if  (value === 'false') {
                return false
            }
        },

        async loginPage() {
            const email = SessionStorage.getItem('email')
            const lang = I18n.get(this)
            this.errorInConsentApi = false
            try {
                await Auth.validConsent(lang, email)
            } catch(error) {
                this.errorInConsentApi = true
                return
            }

            Consent.saveCurrentEmailAsLastConsentAcceptedOnThisDevice()
            Tag.clickAll(this, 'accept', this.provider, this.page, 'new')
            Tag.firstProvider(this, this.provider)
            this.nextPage()
        },

        nextPage() {
            const path = this.toPath + (this.invalidGrant ? '?ig=true' : '')
            routerPushHelper(this.$router, path)

        },

        back() {

            Tag.clickGA(this, 'back', this.provider)

            this.$router.push('/')
        },

        activeConsentPage() {
            if (!this.showPage) {
                this.showPage = true
                Tag.pageViewGA(this, 'consent')
                UserFlow.setPage(this, 'consent')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.consent__page-container {
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $timberwolf;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-image: url(/img/background/cards-desktop.svg);
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: cover;
            background-blend-mode: luminosity;
        }
}

.error{
    color:red;
    text-align: center;
}

.new-consent {
    height: 100vh;
    padding: 30px 20px 50px;
    background-color: $forest;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: $neutralsMoon;
    flex: 1;
    display: flex;
    text-align: start;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: $above-tablet-length) {
        background: unset;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        background-color: $white;
        border-radius: 16px;
        padding-top: 4px;
        max-width: 512px;
        max-height: 95vh;
        @media screen and (min-width: $above-tablet-length) {
            height: fit-content;
        }

        .bloc-consent {
            padding: 16px;

            h1 {
                font-size: 20px;
                font-style: normal;
                font-weight: 700;
                line-height: 28px;
                color: $rifle;
            }

            .cta {
                width: 100%;
                min-height: 56px;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $aquamarine;
                border-radius:32px;
                font-size: 17px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                color: $white;
            }
        }

        .bloc-overflow {
            border: 1px solid $silver;
            padding: 16px;
            flex: 1;
            overflow-y: scroll;
            @media screen and (min-width: $above-tablet-length) {
                flex: none;
            }

            .gap {
                height: 16px;
            }
        }

        .paragraph {
            margin-top: 4px;
        }

        .end-paragraph {
            margin-top: 8px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
        }

        .subtitle {
            color: $rifle;
            font-size: 17px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            display: flex;
            align-content: center;

            > img {
                width: 20px;
                object-fit: contain;
                margin-right: 4px;
            }
        }
    }
}

</style>
